import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import {
  MAT_SNACK_BAR_DATA,
  MatSnackBarRef,
} from '@angular/material/snack-bar';

@Component({
  selector: 'app-success-dialog',
  standalone: true,
  imports: [MatButtonModule, MatIconModule],
  templateUrl: './success-dialog.component.html',
  styleUrl: './success-dialog.component.scss',
})
export class SuccessDialogComponent {
  constructor(
    public snackBarRef: MatSnackBarRef<SuccessDialogComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: { message: string; type: string }
  ) {}
}
